import { render, staticRenderFns } from "./clockAppDesign.vue?vue&type=template&id=15bf5e7f&scoped=true"
import script from "./clockAppDesign.vue?vue&type=script&lang=js"
export * from "./clockAppDesign.vue?vue&type=script&lang=js"
import style0 from "./clockAppDesign.vue?vue&type=style&index=0&id=15bf5e7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bf5e7f",
  null
  
)

export default component.exports